/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

// ---------------------------
// AUTO-GENERATED. DO NOT EAT.
// ---------------------------

import { Tagged, bridgesIsTaggedHack as isTagged } from "@cartographerio/util";

export type Uuid = Tagged<"Uuid">;

export type Semver = Tagged<"Semver">;

export type Email = Tagged<"Email">;

export interface NamedEmail {
  name: string;
  email: Email;
}

export type ScreenName = Tagged<"ScreenName">;

export type UserId = Tagged<"UserId">;

export type SurveyModuleId = Tagged<"SurveyModuleId">;

export type SurveyId = Tagged<"SurveyId">;

export type MapId = Tagged<"MapId">;

export type MapLayerId = Tagged<"MapLayerId">;

export type WorkspaceId = Tagged<"WorkspaceId">;

export type TeamId = Tagged<"TeamId">;

export type ProjectId = Tagged<"ProjectId">;

export type ProjectTemplateId = Tagged<"ProjectTemplateId">;

export type Subdomain = Tagged<"Subdomain">;

export type UnencryptedPassword = Tagged<"UnencryptedPassword">;

export type DataLicense =
  | "Default"
  | "CcBy4"
  | "CcByNd4"
  | "CcBySa4"
  | "CcByNc4"
  | "CcByNcNd4"
  | "CcByNcSa4"
  | "Ogl3";

export type Path = (string | number)[];

export type MessageLevel = "warning" | "error";

export interface Message {
  level: MessageLevel;
  path: Path;
  text: string;
  data?: unknown;
}

export interface Timestamp {
  type: "Timestamp";
  iso8601: string;
}

export interface SearchResults<A> {
  results: A[];
  total: number;
}

export interface ServerVersion {
  name: string;
  version: string;
  booted: Timestamp;
  uptime: number;
}

export interface CheckedSuccess<A> {
  type: "CheckedSuccess";
  value: A;
}

export interface CheckedFailure {
  type: "CheckedFailure";
  errors: Message[];
}

export type Checked<A> = CheckedSuccess<A> | CheckedFailure;

export const isUuid = (v: any): v is Uuid => {
  return isTagged((a0: any): a0 is "Uuid" => a0 === "Uuid")(v);
};

export const isSemver = (v: any): v is Semver => {
  return isTagged((a0: any): a0 is "Semver" => a0 === "Semver")(v);
};

export const isEmail = (v: any): v is Email => {
  return isTagged((a0: any): a0 is "Email" => a0 === "Email")(v);
};

export const isNamedEmail = (v: any): v is NamedEmail => {
  return (
    typeof v === "object" &&
    v != null &&
    "name" in v &&
    typeof v.name === "string" &&
    "email" in v &&
    isEmail(v.email)
  );
};

export const isScreenName = (v: any): v is ScreenName => {
  return isTagged((a0: any): a0 is "ScreenName" => a0 === "ScreenName")(v);
};

export const isUserId = (v: any): v is UserId => {
  return isTagged((a0: any): a0 is "UserId" => a0 === "UserId")(v);
};

export const isSurveyModuleId = (v: any): v is SurveyModuleId => {
  return isTagged((a0: any): a0 is "SurveyModuleId" => a0 === "SurveyModuleId")(
    v
  );
};

export const isSurveyId = (v: any): v is SurveyId => {
  return isTagged((a0: any): a0 is "SurveyId" => a0 === "SurveyId")(v);
};

export const isMapId = (v: any): v is MapId => {
  return isTagged((a0: any): a0 is "MapId" => a0 === "MapId")(v);
};

export const isMapLayerId = (v: any): v is MapLayerId => {
  return isTagged((a0: any): a0 is "MapLayerId" => a0 === "MapLayerId")(v);
};

export const isWorkspaceId = (v: any): v is WorkspaceId => {
  return isTagged((a0: any): a0 is "WorkspaceId" => a0 === "WorkspaceId")(v);
};

export const isTeamId = (v: any): v is TeamId => {
  return isTagged((a0: any): a0 is "TeamId" => a0 === "TeamId")(v);
};

export const isProjectId = (v: any): v is ProjectId => {
  return isTagged((a0: any): a0 is "ProjectId" => a0 === "ProjectId")(v);
};

export const isProjectTemplateId = (v: any): v is ProjectTemplateId => {
  return isTagged(
    (a0: any): a0 is "ProjectTemplateId" => a0 === "ProjectTemplateId"
  )(v);
};

export const isSubdomain = (v: any): v is Subdomain => {
  return isTagged((a0: any): a0 is "Subdomain" => a0 === "Subdomain")(v);
};

export const isUnencryptedPassword = (v: any): v is UnencryptedPassword => {
  return isTagged(
    (a0: any): a0 is "UnencryptedPassword" => a0 === "UnencryptedPassword"
  )(v);
};

export const isDataLicense = (v: any): v is DataLicense => {
  return (
    v === "Default" ||
    v === "CcBy4" ||
    v === "CcByNd4" ||
    v === "CcBySa4" ||
    v === "CcByNc4" ||
    v === "CcByNcNd4" ||
    v === "CcByNcSa4" ||
    v === "Ogl3"
  );
};

export const isPath = (v: any): v is Path => {
  return (
    Array.isArray(v) &&
    v.every((i: any) => typeof i === "string" || typeof i === "number")
  );
};

export const isMessageLevel = (v: any): v is MessageLevel => {
  return v === "warning" || v === "error";
};

export const isMessage = (v: any): v is Message => {
  return (
    typeof v === "object" &&
    v != null &&
    "level" in v &&
    isMessageLevel(v.level) &&
    "path" in v &&
    isPath(v.path) &&
    "text" in v &&
    typeof v.text === "string" &&
    (!("data" in v) || true)
  );
};

export const isTimestamp = (v: any): v is Timestamp => {
  return (
    typeof v === "object" &&
    v != null &&
    "type" in v &&
    v.type === "Timestamp" &&
    "iso8601" in v &&
    typeof v.iso8601 === "string"
  );
};

export const isSearchResults =
  <A>(isA: (a: any) => a is A) =>
  (v: any): v is SearchResults<A> => {
    return (
      typeof v === "object" &&
      v != null &&
      "results" in v &&
      Array.isArray(v.results) &&
      v.results.every((i: any) => isA(i)) &&
      "total" in v &&
      typeof v.total === "number"
    );
  };

export const isServerVersion = (v: any): v is ServerVersion => {
  return (
    typeof v === "object" &&
    v != null &&
    "name" in v &&
    typeof v.name === "string" &&
    "version" in v &&
    typeof v.version === "string" &&
    "booted" in v &&
    isTimestamp(v.booted) &&
    "uptime" in v &&
    typeof v.uptime === "number"
  );
};

export const isCheckedSuccess =
  <A>(isA: (a: any) => a is A) =>
  (v: any): v is CheckedSuccess<A> => {
    return (
      typeof v === "object" &&
      v != null &&
      "type" in v &&
      v.type === "CheckedSuccess" &&
      "value" in v &&
      isA(v.value)
    );
  };

export const isCheckedFailure = (v: any): v is CheckedFailure => {
  return (
    typeof v === "object" &&
    v != null &&
    "type" in v &&
    v.type === "CheckedFailure" &&
    "errors" in v &&
    Array.isArray(v.errors) &&
    v.errors.every((i: any) => isMessage(i))
  );
};

export const isChecked =
  <A>(isA: (a: any) => a is A) =>
  (v: any): v is Checked<A> => {
    return (
      isCheckedSuccess((a0: any): a0 is A => isA(a0))(v) || isCheckedFailure(v)
    );
  };

/* eslint-enable @typescript-eslint/explicit-module-boundary-types */
/* eslint-enable @typescript-eslint/no-use-before-define */
/* eslint-enable @typescript-eslint/no-unused-vars */
/* eslint-enable @typescript-eslint/no-explicit-any */
/* eslint-enable @typescript-eslint/no-empty-interface */
